import { Component, computed, inject, input } from "@angular/core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";
import { MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { MarketPriceStatisticsHeaderComponent } from "../market-price-statistics-header/market-price-statistics-header.component";
import { MarketPriceStatisticsEstateComponent } from "../market-price-statistics-estate/market-price-statistics-estate.component";
@Component({
    selector: "market-price-statistics",
    imports: [MarketPriceStatisticsHeaderComponent, MarketPriceStatisticsEstateComponent],
    templateUrl: "./market-price-statistics.component.html",
    styleUrl: "./market-price-statistics.component.scss",
})
export class MarketPriceStatisticsComponent {
    statistics = input.required<StatisticsLine[]>();

    private readonly mapStateService = inject(MarketSalesStateService);

    filterForm = this.mapStateService.filterForm;

    totals = computed(() => {  
      return this.getTotals(this.statistics());
    })

    estateStats = computed(() => {
      return this.createEstateArray(this.statistics()); 
    })

    toggleUnCertainPrices(event: any): void {
        this.filterForm.searchViewOptions.includeUnCertainPrices().value.set(false);
    }

    toggleJudicialTransfer(event: any): void {
        this.filterForm.searchViewOptions.includeJudicialTransfers().value.set(false);
    }

    private getTotals(stat: StatisticsLine[]): StatisticsLine {
        return stat?.find((x) => x.isTotal);
    }

      private createEstateArray(stat: StatisticsLine[]): StatisticsLine[] {
        return stat?.filter((x) => !x.isTotal);
    }
}
